import React from 'react';
import {
  Box,
  Typography,
  CircularProgress,
  Button
} from '@mui/material';
import { 
  Add as AddIcon, 
  Assignment as AssignmentIcon,
  TaskAlt as TaskIcon
} from '@mui/icons-material';
import TaskGrid from './TaskGrid';
import TasksTable from './TasksTable';

interface TasksDailyViewProps {
  loading: boolean;
  filteredTasks: any[];
  statusFilter: string;
  personnelFilter: string;
  viewMode: 'card' | 'list';
  onShowTaskDetail: (task: any) => void;
  onOpenQrPrintModal: (task: any, event: React.MouseEvent) => void;
  getStatusColor: (status: string) => string;
  getStatusIcon: (status: string) => React.ReactNode;
  getStatusLabel: (status: string) => string;
  getTaskTimeColor: (task: any, timeString: string) => string;
  companyId: string | null;
  onOpenDeviceModal: (deviceInfo: any) => void;
  setAddTaskModalOpen: (open: boolean) => void;
  branches: {[key: string]: string};
  onOpenTaskLocationModal: (task: any) => void; // Yeni prop
}

const TasksDailyView: React.FC<TasksDailyViewProps> = ({
  loading,
  filteredTasks,
  statusFilter,
  personnelFilter,
  viewMode,
  onShowTaskDetail,
  onOpenQrPrintModal,
  getStatusColor,
  getStatusIcon,
  getStatusLabel,
  getTaskTimeColor,
  companyId,
  onOpenDeviceModal,
  setAddTaskModalOpen,
  branches,
  onOpenTaskLocationModal // Yeni prop
}) => {
  // Sadece tekrarlı görevleri filtrele
  const dailyTasks = filteredTasks.filter(task => task.isRecurring);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (dailyTasks.length === 0) {
    return (
      <Box sx={{ textAlign: 'center', my: 8 }}>
        <TaskIcon sx={{ fontSize: 60, color: 'primary.light', mb: 2 }} />
        <Typography variant="h6" color="textSecondary">
          {
            statusFilter === 'all' && personnelFilter === 'all'
              ? 'Henüz hiç görev eklenmemiş'
              : 'Filtrelere uygun görev bulunamadı'
          }
        </Typography>
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          onClick={() => setAddTaskModalOpen(true)}
          sx={{ mt: 2 }}
        >
          Yeni Görev Ekle
        </Button>
      </Box>
    );
  }

  return viewMode === 'card' ? (
    <Box sx={{ mb: 3 }}>
      <TaskGrid
        tasks={dailyTasks}
        onShowTaskDetail={onShowTaskDetail}
        onOpenQrPrintModal={onOpenQrPrintModal}
        getStatusColor={getStatusColor}
        getStatusIcon={getStatusIcon}
        getStatusLabel={getStatusLabel}
        getTaskTimeColor={getTaskTimeColor}
        onOpenDeviceModal={onOpenDeviceModal}
        taskType="daily"
        branches={branches}
      />
    </Box>
  ) : (
    <Box sx={{ mb: 3 }}>
      <TasksTable
        tasks={dailyTasks}
        statusFilter={statusFilter}
        onShowTaskDetail={onShowTaskDetail}
        onOpenQrPrintModal={onOpenQrPrintModal}
        getStatusColor={getStatusColor}
        getStatusIcon={getStatusIcon}
        getStatusLabel={getStatusLabel}
        getTaskTimeColor={getTaskTimeColor}
        companyId={companyId}
        onOpenDeviceModal={onOpenDeviceModal}
        taskType="daily"
        branches={branches}
        onOpenTaskLocationModal={onOpenTaskLocationModal} // Propu dooru yere ekle
      />
    </Box>
  );
};

export default TasksDailyView; 